import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activitySettingsFormFieldRoutes: MenuInterface[] = [
    {
        code: 'FormField', // GestionParamChampsFormulaires_ViewModel
        route: [
            {
                content: '$type/settings/form-field/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ]
    }
];
